import { z } from "zod";

const transactionTypes = ["CAPTURE", "REFUND"] as const;
type TransactionType = typeof transactionTypes[number];

const transactionTypesZodSchema = z.enum(transactionTypes);

export { transactionTypes, transactionTypesZodSchema };
export type { TransactionType };
